export function priceReduced(rows: Array<Record<string, any>>) {
  return rows.reduce((a, b) => {
    if (b.status === 'DELIVERED') {
      if (Number(b.collected_amount) === 0) {
        return a;
      } else {
        return a + Number(b.merchant_COD) - Number(b.collected_amount);
      }
    }
    return a;
  }, 0);
}

export function collected(rows: Array<Record<string, any>>) {
  return rows.reduce((a, b) => {
    if (['PAYMENT', 'ON_DELIVERY', 'PICKED', 'BOOKING', 'PENDING'].includes(b.status)) {
      return a;
    } else {
      if (Number(b.collected_amount) === 0 && b.status !== 'RETURNED') {
        return a + b.merchant_COD;
      } else {
        return a + b.collected_amount;
      }
    }
  }, 0);
}

export function payment(rows: Array<Record<string, any>>) {
  return rows.reduce((a, b) => (['PAYMENT'].includes(b.status) ? a + b.collected_amount : a), 0);
}

export function deliveryCharge(rows: Array<Record<string, any>>) {
  return rows.reduce((a, b) => a + (b.deliveryCharge ?? 0), 0) * -1;
}
